import { IList } from '@brighterion/types/list';
import { StateCreator } from 'zustand';

export const initialCurrentListIdState: string | null = '';

export const initialListState: IList[] | null = [];

export const initialListPollingData: Record<string, any>[] = [];

export interface ListSlice {
    currentListId: string | null;
    currentListCount: number | null;
    list: IList[];
    setList: (data: IList[]) => void;
    setCurrentListId: (data: string) => void;
    setCurrentListCount: (count: number) => void;
    listPollingData: Record<string, any>[];
    setListPollingData: (data: Record<string, any>[]) => void;
}

export const createListSlice: StateCreator<ListSlice, [], [], ListSlice> = (set) => ({
    currentListId: initialCurrentListIdState,
    currentListCount: 0,
    list: [...initialListState],
    setList: (data: IList[]) => set({ list: data }),
    setCurrentListId: (id: string) => set({ currentListId: id }),
    setCurrentListCount: (count: number) => set({ currentListCount: count }),
    listPollingData: [...initialListPollingData],
    setListPollingData: (data: Record<string, any>[]) => set({ listPollingData: data })
});
